/**
 * Currency formatter for South African Rand (ZAR)
 * Locale: en-ZA
 */
export const formatZAR = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) {return 'R 0.00';}

  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

/**
 * Percentage formatter
 */
export const formatPercent = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) {return '0%';}
  return `${num.toFixed(1)}%`;
};
